var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aboutus"},[_c('InfoSection'),_c('TestimonialsContent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }